import Model from '../utils/Model'
import CommonState from '@/class/cargo/model/parameters/CommonState'

export class EdiState {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const PROCESSING = new EdiState(1, '上传完成,处理中', 'processing')
export const UPLOAD_SUCCESS = new EdiState(2, '上传成功', 'upload success')
export const CONFIRM_SUCCESS = new EdiState(3, '处理成功', 'confirm success')
export const CONFIRM_FAILURE = new EdiState(4, '处理失败', 'confirm failure')
export const ORIGINAL = new EdiState(5, '原始', 'original')
export const UPDATE = new EdiState(6, '更正', 'update')
export const DELETE = new EdiState(7, '删除', 'delete')
// 订舱及通讯回执
export const RECEIPT_ORIGINAL = new EdiState(8, '原始', 'Original')
export const RECEIPT_REPLACEMENT = new EdiState(9, '更改', 'Replacement')
export const RECEIPT_CANCELLATION = new EdiState(10, '取消', 'Cancellation')
export const RECEIPT_RECEIVE = new EdiState(11, '接收', 'Received')
export const RECEIPT_REFUSE = new EdiState(12, '拒绝', 'Rejected')
export const RECEIPT_CONFIRMED = new EdiState(13, '确认', 'Confirmed')
export const RECEIPT_AP = new EdiState(14, '接收', 'Received')
export const RECEIPT_AD = new EdiState(15, '异常', 'Warning')
export const RECEIPT_RE = new EdiState(16, '不接受', 'Rejected')
export const KIN_NIT_ACCEPT = new EdiState(17, '已接单', 'Accept')
export const KIN_NIT_REJECT = new EdiState(18, '被拒绝', 'Rejected')

export const EDI_STATES = [PROCESSING, UPLOAD_SUCCESS, CONFIRM_SUCCESS, CONFIRM_FAILURE, ORIGINAL, UPDATE, DELETE,
  RECEIPT_ORIGINAL, RECEIPT_REPLACEMENT, RECEIPT_CANCELLATION, RECEIPT_RECEIVE, RECEIPT_REFUSE, RECEIPT_CONFIRMED,
  RECEIPT_AP, RECEIPT_AD, RECEIPT_RE, KIN_NIT_ACCEPT, KIN_NIT_REJECT]

// 海管家舱单状态
export const NOT_SENT_EMPTY = new CommonState('', '未发送', 'Not sent')
export const NOT_SENT = new CommonState('-1', '未发送', 'Not sent')
export const NOT_SENT0 = new CommonState('0', '未发送', 'Not sent')
export const ORIGINAL_AWAITING = new CommonState('1', '原始舱单等待回执', 'The original manifest is awaiting receipt')
export const ORIGINAL_CORRECT = new CommonState('21', '原始舱单回执正确', 'The original manifest receipt is correct')
export const ORIGINAL_INCORRECT = new CommonState('22', '原始舱单回执错误', 'The original manifest receipt is incorrect')
export const ORIGINAL_REFUND = new CommonState('23', '原始舱单退单', 'Refund of the original manifest')
export const CHANGE_PENDING = new CommonState('3', '更改舱单等待回执', 'Change manifest pending receipt')
export const CHANGE_CORRECT = new CommonState('44', '更改舱单回执正确', 'The change manifest receipt is correct')
export const CHANGE_ERROR = new CommonState('45', '更改舱单回执错误', 'Change manifest receipt error')
export const DELETE_WAIT = new CommonState('5', '删除舱单等待回执', 'Delete the manifest and wait for receipt')
export const DELETION_CORRECT = new CommonState('61', '删除舱单回执正确', 'The deletion manifest receipt is correct')
export const DELETE_FAILED = new CommonState('63', '删除舱单回执失败', 'Failed to delete manifest receipt')
export const CHARGEBACKS = new CommonState('9', '退单', 'Chargebacks')
export const SEND_TYPES = [NOT_SENT_EMPTY, NOT_SENT, NOT_SENT0, ORIGINAL_AWAITING, ORIGINAL_CORRECT, ORIGINAL_INCORRECT, ORIGINAL_REFUND,
  CHANGE_PENDING, CHANGE_CORRECT, CHANGE_ERROR, DELETE_WAIT, DELETION_CORRECT, DELETE_FAILED, CHARGEBACKS]
export const MODIFY_TYPES = [ORIGINAL_AWAITING, ORIGINAL_CORRECT, ORIGINAL_REFUND,
  CHANGE_PENDING, CHANGE_CORRECT, DELETE_WAIT, DELETE_FAILED, CHARGEBACKS, ORIGINAL_INCORRECT, CHANGE_ERROR]

export const ORIGINAL_SUCCESS = new CommonState('21', '发送成功', 'Send successfully')
export const CHANGE_SUCCESS = new CommonState('44', '更改成功', 'Change successfully')
export const DELETION_SUCCESS = new CommonState('61', '删除成功', 'Delete successfully')
export const CANCEL_SUCCESS = new CommonState('99', '撤单成功', 'Cancel successfully')
export const ALLOW_MODIFY_TYPES = [DELETION_SUCCESS, ORIGINAL_SUCCESS, CHANGE_SUCCESS, CANCEL_SUCCESS]

// 根据状态查询
export function getEdiStateByStatus(status) {
  return Model.getObjByCode(status, EDI_STATES)
}

